import React from 'react';
import arrow from '../../../assets/images/select-arrow.svg';
import { PLACEHOLDER_OPT } from '../Schemas/baseRrf';

import './styles.css';

export const SELECT_STYLE = Object.freeze({ WHITE: 0, BLUE: 1 });

const Select = ({
  value,
  onChange,
  disabled,
  children,
  selectStyle = SELECT_STYLE.WHITE,
  id,
  name,
}) => {
  const displayValue = value === '' ? PLACEHOLDER_OPT : value;
  const styleName = selectStyle === SELECT_STYLE.WHITE ? 'selectWrapper' : 'selectWrapperBlue';
  const selectStyleName = selectStyle === SELECT_STYLE.WHITE ? 'selectDefault' : 'selectBlue';
  return (
    <div styleName={styleName}>
      <select
        styleName={selectStyleName}
        value={displayValue}
        onChange={onChange}
        disabled={disabled}
        id={id}
        name={name}
      >
        {children}
      </select>
      <input
        type="image"
        styleName="filterArrow"
        src={arrow}
        alt="arrow"
      />
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/Select.js